import React, { useState } from 'react';
import { Fab } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { useAppContext } from 'hooks/useAppContext';

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  extendedIcon: {
    margin: 0,
    top: 95,
    left: 'auto',
    bottom: 'auto',
    right: 20,
    position: 'fixed',
    zIndex: 1,
    backgroundColor: theme.palette.fab
  }
}));

const FloatingActionButton = ({ onClick, href, children }) => {
  const [hover, setHover] = useState(false);
  const { currentModule } = useAppContext();
  const classes = useStyles();
  return (
    <>
      {!hover && 
        <Fab color="primary" aria-label="add" className={classes.extendedIcon} style={{ top: "92vh" }} onClick={onClick} href={href} onMouseOver={(e) => setHover(true)}>
          {children}
        </Fab>
      }
      {!!hover &&
        <Fab color="primary" variant="extended" aria-label="add" className={classes.extendedIcon} style={{ top: "92vh" }} onClick={onClick} href={href} onMouseLeave={(e) => setHover(false)}>
          {children}
          {`Add ${currentModule || "project"}`}
        </Fab>}
    </>
  )
};

FloatingActionButton.propTypes = {
  onClick: PropTypes.func,
  href: PropTypes.string,
  children: PropTypes.node
};

export default FloatingActionButton; 